import React, {
  ComponentPropsWithoutRef,
  ElementType,
  useCallback,
} from 'react';
import classnames from 'classnames';

import './TextArea.scss';

export interface TextAreaProps extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  value?: string;
  onChange?;
  hasError?: boolean;
}

const TextArea = ({
  className,
  value,
  onChange,
  hasError,
  ...props
}: TextAreaProps) => {
  const handleChange = useCallback(
    ({ target: { value } }) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange],
  );

  return (
    <textarea
      className={classnames(
        'textarea',
        { textarea_error: hasError },
        className,
      )}
      value={value}
      onChange={handleChange}
      {...props}
    />
  );
};

export default TextArea;
